import dayjs from '@dayjs';
import { AUTH_CLEAR_USER_INFO, AUTH_SET_USER_INFO, SET_REALM } from './action';

const init = {
  user: {},
  store: {},
  org: {},
  subscription: {},
  sgAuth: null,
  loggedIn: false,
  realm: null,
  timezone: dayjs.tz.guess(),
  dateFormat: 'lll',
  countryCode: 'IN',
  currency: 'INR',
};

export default (state = init, action = null) => {
  let newState = { ...state };
  switch (action.type) {
    case SET_REALM:
      newState.realm = action.payload;
      break;
    case AUTH_SET_USER_INFO:
      newState = { ...newState, ...action.payload };
      if (action.payload.user.timezone) newState.timezone = action.payload.user.timezone;
      if (action.payload.user.dateFormat) newState.dateFormat = action.payload.user.dateFormat;

      if (action.payload.store?.profile?.countryCode) newState.countryCode = action.payload.store.profile.countryCode;
      if (action.payload.store?.profile?.currencyCode) newState.currency = action.payload.store.profile.currencyCode;
      if (!newState.countryCode && action.payload.user.country) newState.countryCode = action.payload.user.country;
      if (!newState.currency && action.payload.user.currency) newState.currency = action.payload.user.currency;

      newState.loggedIn = true;
      break;
    case AUTH_CLEAR_USER_INFO:
      newState.user = null;
      newState.loggedIn = false;
      break;
    default:
  }
  return newState;
};
